export const focusFirstInvalidField = (fieldNames: string[]) => {
  window.requestAnimationFrame(() => {
    for (const field of fieldNames) {
      const element =
        (document.getElementById(field) as HTMLElement | null) ||
        (document.querySelector(`[name="${field}"]`) as HTMLElement | null)

      if (!element) continue

      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      element.focus({ preventScroll: true })
      return
    }
  })
}
